import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  role?: string;
  tabIndex?: number;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  'aria-label'?: string;
  'aria-describedby'?: string;
}

export function Card({ 
  children, 
  className = '', 
  onClick,
  role,
  tabIndex,
  onKeyDown,
  'aria-label': ariaLabel,
  'aria-describedby': ariaDescribedBy
}: CardProps) {
  return (
    <div 
      onClick={onClick}
      onKeyDown={onKeyDown}
      role={role}
      tabIndex={tabIndex}
      aria-label={ariaLabel}
      aria-describedby={ariaDescribedBy}
      className={`
        bg-white rounded-xl border border-idecide-primary shadow-sm
        hover:shadow-md transition-shadow duration-200
        ${onClick ? 'cursor-pointer focus:outline-none focus:ring-2 focus:ring-idecide-primary focus:ring-offset-2' : ''}
        ${className}
      `}
    >
      {children}
    </div>
  );
}